import type { BlockRecord } from './types';

export type PageDocument = {
  block: BlockRecord;
  contentBlocks: BlockRecord[];
};

const cache = new Map<string, PageDocument>();

export function getCachedPageDocument(pageId: string): PageDocument | null {
  return cache.get(pageId) ?? null;
}

export function setCachedPageDocument(pageId: string, document: PageDocument): void {
  cache.set(pageId, document);
}

export function invalidatePageDocument(pageId: string): void {
  cache.delete(pageId);
}

export function clearAllPageDocuments(): void {
  cache.clear();
}

export function updateCachedPageTitle(pageId: string, title: string): void {
  const entry = cache.get(pageId);
  if (!entry) {
    return;
  }
  cache.set(pageId, {
    ...entry,
    block: { ...entry.block, title },
  });
}
